import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AccordionModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  expanded: boolean = false;
  @Input() item: any;
  @Input() selectedItem: any;
  @Input() onSelect: any;
  @Output() itemSelectedEvent = new EventEmitter<any>();

  constructor(private router: Router) {}

  ngOnInit() {}

  expandOn(item: any) {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.onSelect(item);
    }
  }

  itemSelected(item: any) {
    this.selectedItem = null;
    this.onSelect(item);
    if(item?.link !== undefined){
      this.router.navigateByUrl(item.link);
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItem === item;
  }
}
